// LoginPage.jsx
import React from 'react';
import {
  Avatar,
  Box,
  Typography,
  Container,
  Paper
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from "react-router-dom";
import { GoogleLogin  } from "@react-oauth/google";
import { saveUserAuth } from "../services/user";
import logo from '../logoSize.svg';

export default function LoginPage() {
    const navigate = useNavigate();

    return (

        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{
                padding: { xs: 2, sm: 4 },
                marginTop: { xs: 4, sm: 8 }
            }}>
            <Box
                sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                }}
            >
                <img src={logo} alt="logo" style={{ maxWidth: '100%', height: 'auto', marginBottom: '16px' }}/>
                {/* <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    
                </Avatar> */}
                <Typography component="h1" variant="h5">
                    Sign In
                </Typography>
                <Box sx={{
                    paddingTop: '10px',
                    flexDirection: 'column',
                    alignItems: 'center',
                    }}>
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        saveUserAuth(credentialResponse);
                        navigate("/"); // ✅ Redirect on success
                    }}
                    onError={() => {
                    console.error("Login Failed");
                    navigate("/login-error"); // ❌ Redirect on failure
                    }}
                />
                </Box>
            </Box>
            </Paper>
        </Container>
    );
}
